import { Component } from 'react';

import { PageLimitLabelStyled } from './styles/PageLimitLabelStyled'
import { PageLimitSelectStyled } from './styles/PageLimitSelectStyled'
import { PageLimitStyled } from './styles/PageLimitStyled'
import { type ISelectProps, Select } from '../../elements/Select'

export interface IPageLimitProps {
  value?: PageLimitValue
  options?: PageLimitValue[]
  onChange?: ISelectProps['onChange']
}

export interface PageLimitValue {
  value: string
  label: string
}

export class PageLimit extends Component<IPageLimitProps> {
  static defaultProps = {
    value: { value: '10', label: '10' },
    options: [
      { value: '10', label: '10' },
      { value: '25', label: '25' },
      { value: '50', label: '50' },
      { value: '100', label: '100' },
    ],
  }

  render() {
    const { value, options, onChange } = this.props

    return (
      <PageLimitStyled>
        <PageLimitLabelStyled htmlFor='results-per-page-select'>
          Results Per Page:{' '}
        </PageLimitLabelStyled>
        <PageLimitSelectStyled>
          <Select
            inputId='results-per-page-select'
            className='select'
            value={value}
            onChange={onChange}
            options={options}
          />
        </PageLimitSelectStyled>
      </PageLimitStyled>
    )
  }
}
